<template>
  <div class="lesson-list-area" :class="{ 'new-distance': !isInNative }">
    <div class="shop-header">
      <EntitySecond :itemData="storeInfo" />
      <Nav :navData="menuInfo || []" />
    </div>

    <div class="sort-area" @click.stop.prevent>
      <span
        :class="{
          sync: true,
          'sort-selected':
            this.sort == 'sort_hot' ||
            this.sort == 'sort_new' ||
            this.sort == 'sort_score'
        }"
        @click="openSortArea()"
        >{{ sortText }} <span class="icon-more"></span></span
      >
      <!-- <span
        :class="{sync:true,'sort-selected':this.sort=='sort_hot' }"
        @click="()=>{sortBySync(1)}"
      >综合</span> -->
      <!-- <span
        :class="{newest:true,'sort-selected':this.sort=='sort_new'}"
        @click="()=>{sortByTime(1)}"
      >最新</span> -->
      <span
        :class="{
          'order-number': true,
          'sort-selected': this.sort == 'sort_sales'
        }"
        @click="
          () => {
            sortByOrder(1);
          }
        "
        >销量</span
      >
      <span
        :class="{ price: true, 'sort-selected': this.sort == 'sort_price' }"
        @click="
          () => {
            sortByPrice(1);
          }
        "
      >
        <span>价格</span>
        <div class="sanjiao-icon">
          <div
            :class="{
              'top-sanjiao': true,
              'top-sanjiao-selected': this.priceSort == 'asc'
            }"
          ></div>
          <div
            :class="{
              'down-sanjiao': true,
              'down-sanjiao-selected': this.priceSort == 'desc'
            }"
          ></div>
        </div>
      </span>
    </div>
    <div
      class="course-sort-model"
      v-show="sortAreaShow"
      @click="
        () => {
          this.sortAreaShow = false;
        }
      "
      @touchmove.stop.prevent
    >
      <div class="course-sort-model-area">
        <p
          class="sort-model-item"
          :class="{ sync: true, 'sort-selected': this.sort == 'sort_hot' }"
          @click="
            () => {
              sortBySync(1);
            }
          "
        >
          综合排序
        </p>
        <p
          class="sort-model-item"
          :class="{ newest: true, 'sort-selected': this.sort == 'sort_new' }"
          @click="
            () => {
              sortByTime(1);
            }
          "
        >
          最新上架
        </p>
        <p
          class="sort-model-item"
          :class="{ newest: true, 'sort-selected': this.sort == 'sort_score' }"
          @click="
            () => {
              sortByScore(1);
            }
          "
        >
          好评优先
        </p>
      </div>
    </div>
    <div
      class="g-content lesson-list"
      v-if="columnList && columnList.length > 0"
    >
      <div class="column" v-for="(column, index) in columnList" :key="index">
        <CourseItem01
          :itemData="handleData(column)"
          :storeInfo="storeInfo"
          :sortKey="index + 1"
          ref="courseItem"
        >
          <div slot="price" class="price ellipisis">
            <span>
              <span class="column-number"
                >{{ column.totalLessonNumbers }}集
                <span
                  v-if="
                    column.price || column.originalPrice || column.freeStatus
                  "
                  >|&nbsp;</span
                ></span
              >
              <span class="discout-price" v-if="column.freeStatus">免费</span>
              <span
                class="discout-price"
                v-if="!column.freeStatus && column.price"
                >{{
                  column.price / 100 == 0 ? "0" : "￥" + column.price / 100
                }}</span
              >
              <span
                class="discout-price"
                v-if="
                  !column.freeStatus && !column.price && column.originalPrice
                "
                >{{
                  column.originalPrice / 100 == 0
                    ? "0"
                    : "￥" + column.originalPrice / 100
                }}</span
              >
              <span
                class="original-price"
                v-if="column.price && column.price < column.originalPrice"
                >{{
                  column.originalPrice / 100 == 0
                    ? ""
                    : column.originalPrice / 100
                }}</span
              >
            </span>
            <span class="player-count ellipisis" v-if="!!column.playUserCount"
              >{{ column.playUserCount | showNumber }}人学过</span
            >
          </div>
        </CourseItem01>
      </div>
    </div>
    <zs-infinite
      ref="infinite"
      @infinite="onLoadData"
      :isAutoLoad="true"
      noResultText
      no-more-text="没有更多内容了"
    >
      <placeholder slot="no-results" icon="play" title="店铺还没有课程哦" />
    </zs-infinite>
  </div>
</template>
<script>
import EntitySecond from "../../components/items/Entity2";
import Placeholder from "@/components/placeholder.vue";
import Nav from "../../components/cards/Nav";
import Api from "../../service/api";
import CourseItem01 from "../../components/items/course-item-01";
import store from "../../store";
import { mapGetters } from "vuex";
import pv from "@/service/pingback/pv";
import _ from "@/utils/util";

export default {
  components: {
    EntitySecond,
    Nav,
    CourseItem01,
    Placeholder
  },
  data() {
    return {
      title: "全部课程页",
      shopData: {},
      columnList: [],
      pageIndex: 0,
      pageSize: 10,
      pageTotal: 0,
      dataTotal: 0,
      sort: "sort_hot",
      showLoading: true,
      pageKey: "",
      priceSort: "",
      isInNative: false,
      sortAreaShow: false
    };
  },
  computed: {
    ...mapGetters("category", {
      storeInfo: "getStoreInfo",
      menuInfo: "getMenuInfo"
    }),
    sortText() {
      if (this.sort === "sort_new") return "最新上架";
      if (this.sort === "sort_score") return "好评优先";
      return "综合排序";
    }
  },
  filters: {
    showNumber(val) {
      return _.showNumber(val);
    }
  },
  mounted () {
    document.getElementById('app').addEventListener('click', () => {
      this.sortAreaShow = false
    })
  },
  methods: {
    openSortArea() {
      this.sortAreaShow = true;
    },
    handleData(data) {
      return {
        contentName: data.properTitle,
        contentPic: data.image && data.image.sourceImageUrl,
        promptDescription: data.promptDescription,
        lecturer: data.lectName,
        contentId: data.columnQipuId,
        lectPromptDescription: data.lectPromptDescription,
        showQipuScore: data.showQipuScore,
        qipuScore: data.qipuScore,
        labelShow: true,
        topList: data.topList,
        features: data.features
      };
    },
    async getDataBySort(
      sortType = "sort_hot",
      currentPage = 1,
      qiyihao_id = this.storeInfo.iqiyiId,
      sort = "desc"
    ) {
      let data = await Api.getLessonList({
        currentPage: currentPage,
        direction: sort,
        sortType: sortType,
        qiyihao_id: qiyihao_id
      });
      this.pageIndex = 0;
      this.pageTotal = data.totalPage;
      this.dataTotal = data.total;
      return data;
    },
    async sortBySync() {
      this.columnList = [];
      this.sort = "sort_hot";
      this.priceSort = "";
      this.pageIndex = 0;
      this.$refs.infinite.reset();
      pv.click({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        block: "screening_items",
        rseat: "sort_hot",
        type: 20
      });
      this.$router.push({
        name: "lesson-list",
        params: { pageId: `${this.pageKey}.html` },
        query: {
          sort: "sort_hot"
        }
      });
      this.sortAreaShow = false;
    },
    async sortByTime() {
      this.columnList = [];
      this.sort = "sort_new";
      this.priceSort = "";
      this.pageIndex = 0;
      this.$refs.infinite.reset();
      pv.click({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        block: "screening_items",
        rseat: "sort_new",
        type: 20
      });
      this.$router.push({
        name: "lesson-list",
        params: { pageId: `${this.pageKey}.html` },
        query: {
          sort: "sort_new"
        }
      });
      this.sortAreaShow = false;
    },
    async sortByOrder() {
      this.sortAreaShow = false
      this.columnList = [];
      this.sort = "sort_sales";
      this.priceSort = "";
      this.pageIndex = 0;
      this.$refs.infinite.reset();
      pv.click({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        block: "screening_items",
        rseat: "sort_order",
        type: 20
      });
      this.$router.push({
        name: "lesson-list",
        params: { pageId: `${this.pageKey}.html` },
        query: {
          sort: "sort_sales"
        }
      });
    },
    async sortByPrice() {
      this.sortAreaShow = false
      this.columnList = [];
      this.sort = "sort_price";
      if (this.priceSort === "asc") {
        this.priceSort = "desc";
      } else {
        this.priceSort = "asc";
      }
      this.pageIndex = 0;
      this.$refs.infinite.reset();
      pv.click({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        block: "screening_items",
        rseat: "sort_price",
        type: 20
      });
      this.$router.push({
        name: "lesson-list",
        params: { pageId: `${this.pageKey}.html` },
        query: {
          sort: "sort_price"
        }
      });
    },
    async sortByScore() {
      this.columnList = [];
      this.sort = "sort_score";
      this.pageIndex = 0;
      this.$refs.infinite.reset();
      pv.click({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        block: "screening_items",
        rseat: "sort_score",
        type: 20
      });
      this.$router.push({
        name: "lesson-list",
        params: { pageId: `${this.pageKey}.html` },
        query: {
          sort: "sort_score"
        }
      });
      this.sortAreaShow = false;
    },
    async getShopData() {
      let param = this.$route.params.pageId;
      let arr = [];
      if (param) {
        arr = param.split(".html");
      }
      let data = await Api.read(arr[0], "", false);
      this.navData = (data && data.tabs) || [];
      pv.send({
        rpage: `knowledge_h5_shop_${data.storeInfo.key}_${data.storeInfo.name}`,
        v: 1
      });
      //存储店铺和菜单信息
      store.dispatch("category/storeInfo", {
        storeInfo: data.storeInfo || {}
      });
      store.dispatch("category/menuInfo", {
        menuInfo: this.navData
      });
      return data;
    },
    /**
     * 加载第N页
     */
    async load(pageIndex, iqiyiId) {
      try {
        let data = await this.getDataBySort(
          this.sort,
          this.pageIndex + 1,
          iqiyiId,
          this.priceSort
        );
        this.columnList = this.columnList.concat(data.list || []);
        this.pageIndex = pageIndex;
        this.pageTotal = data.totalPage;
        this.dataTotal = data.total;
      } catch (err) {
        // console.error(err);
        throw err;
      }
    },
    /**
     * 触底回调函数
     */
    async onLoadData() {
      try {
        const $infinite = this.$refs.infinite;
        let id;
        if (!this.storeInfo.iqiyiId) {
          let data = await this.getShopData();
          id = String(data.storeInfo.iqiyiId);
        } else {
          id = String(this.storeInfo.iqiyiId);
        }
        await this.load(this.pageIndex + 1, id);
        const length = this.columnList.length;
        if (this.pageIndex === 1) {
          if (length === 0) {
            $infinite.none();
          } else if (length === this.dataTotal) {
            $infinite.complete(false);
          } else {
            $infinite.loaded();
          }
        } else {
          if (this.pageIndex >= this.pageTotal) {
            $infinite.complete();
          } else {
            $infinite.loaded();
          }
        }
      } catch (err) {
        this.$toast.info(`你的网络有问题哦，请检查网络设置`);
      }
    }
  },
  created() {
    let param = this.$route.params.pageId;
    this.sort = this.$route.query.sort || "sort_hot";

    if (param) {
      let arr = param.split(".html");
      this.pageKey = arr[0];
    }
    if (this.storeInfo.key) {
      pv.send({
        rpage: `knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
        v: 1
      });
    }
    if (window.browser.iqiyi || window.browser.knowledge) {
      this.isInNative = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/func.less";
@import "../../assets/css/var.less";

.lesson-list-area {
  position: relative;
  &.view {
    margin-top: 0px;
  }

  &.new-distance {
    margin-top: -14px !important;
  }

  .lesson-list {
    padding-top: 15px;
    background-color: #fff;
  }

  .sort-area {
    display: flex;
    .set(font-size, 26);
    color: #666;
    .set(height, 80);
    .set(line-height, 80);
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
    background-color: #fff;

    span {
      flex: 1;
    }

    .sync {
    }

    .newest {
    }

    .order-number {
    }

    .price {
      position: relative;

      .sanjiao-icon {
        display: inline-block;
      }

      .top-sanjiao {
        height: 0;
        width: 0;
        overflow: hidden;
        font-size: 0;
        line-height: 0;
        border-style: solid;
        border-width: 4px;
        position: relative;
        top: 2px;
        left: 4px;
        border-color: transparent transparent #666 transparent;
      }

      .down-sanjiao {
        height: 0;
        width: 0;
        overflow: hidden;
        font-size: 0;
        line-height: 0;
        border-style: solid;
        border-width: 4px;
        position: relative;
        top: 5px;
        left: 4px;
        border-color: #666666 transparent transparent transparent;
      }

      .top-sanjiao-selected {
        border-color: transparent transparent rgba(0, 193, 134, 1) transparent !important;
      }

      .down-sanjiao-selected {
        border-color: rgba(0, 193, 134, 1) transparent transparent transparent !important;
      }
    }

    .icon-more {
      display: inline-block;
      .set(width, 24);
      .set(height, 24);
      background: url('../../assets/img/icon_more_gray.png') no-repeat;
      background-size: contain;
      position: relative;
      .set(top, 4);
    }
    .sort-selected {
      color: #00c186;
      font-weight: bold;
      .icon-more {
        background: url('//pic2.iqiyipic.com/kppfe/image/20200415/icon_more_green.png') no-repeat;
        background-size: contain;
      }
    }
  }
  .course-sort-model {
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    .set(top, 340);
    z-index: 50;
    .course-sort-model-area {
      background: #fff;
    }
    .sort-model-item {
      background: #fff;
      .set(height, 100);
      .set(line-height, 100);
      .set(padding-left, 30);
      .set(font-size, 26);
      color: #333;
      &.sort-selected {
        color: #00c186;
        .icon-more {
          background: url('//pic2.iqiyipic.com/kppfe/image/20200415/icon_more_green.png') no-repeat;
          background-size: contain;
        }
      }
    }
  }
}
</style>
